import { EntityLegalForm } from './formsData.model';

export const individEntityForms = [EntityLegalForm.SOLE_TRADER, EntityLegalForm.INDIVIDUAL];
export const getIsIndividualBusiness = (entityType: EntityLegalForm | null | undefined) => {
  return entityType && individEntityForms.includes(entityType);
};
